import { keepPreviousData, useQuery } from '@tanstack/react-query';
import DataApiClient from 'src/utils/DataApiClient';
import { QueryDisabledError } from 'src/utils/error/QueryDisabledError';
import { createQueryKey } from 'src/utils/query/createQueryKey';
import { SNAPSHOTS_QUERY_STALE_TIME } from 'src/hooks/query/snapshots/consts';

function authorityReferralSnapshotsQueryKey(authority?: string, days?: number) {
	return createQueryKey('authorityReferralSnapshots', authority, days);
}

interface Params {
	authority: string | undefined;
	days?: number;
}

interface Snapshot {
	ts: number;
	referralRewards: number;
	referralCount: number;
	referredUsers: string[];
	referredVolume30D: number;
}

interface ResponseData {
	success: boolean;
	snapshots: Snapshot[];
}

export default function useAuthorityReferralSnapshots({
	authority,
	days,
}: Params) {
	const disabled = !authority;

	return useQuery({
		queryKey: authorityReferralSnapshotsQueryKey(authority, days),
		queryFn: () => {
			if (disabled) {
				throw new QueryDisabledError();
			}

			return DataApiClient.fetchSnapshotData<ResponseData>({
				level: 'authority',
				resource: 'referrals',
				params: { authority, days },
			});
		},
		enabled: !disabled,
		placeholderData: disabled ? undefined : keepPreviousData,
		staleTime: SNAPSHOTS_QUERY_STALE_TIME,
	});
}
